import React, { useContext } from 'react';
import { Row, Col } from 'react-bootstrap';
import SearchSettings from '../../SearchSettings';
import Pagination from '../../Pagination';
import PageSwitcher from "../../PageSwitcher";
import Loading from '../../Loading';
import FullTextSearch from '../../FullTextSearch';
import { SearchContext } from '../../../context/Search';
import TableContainer from '../../TableContainer';
import AlertMessage from '../../AlertMessage';
import { useLocation } from 'react-router-dom';

const BUSINESS_ALERT = `
  <div>
    <p>
      <b>About the Future Opportunities</b> The information provided in this searchable database includes future opportunities, and is intended for
      informational purposes and subject to change without notice. These are not solicitations or open bids. The data has been collected and 
      sourced by the North Carolina Military Business Center to provide businesses information to prepare and pre-position for success.
    </p>
    <p>
      <b>How to Navigate</b> Use the search bar above to search by agency, NAICS code, NCMBC Representative, Industry, location or contract title keyword.
    </p>
    <p className="mb-0">
      <b>NCMBC Advanced Search for Future Opportunities</b> For a more advanced search, please refer to the Future Opportunities<br />
      page on the NCMBC site - <a href="http://futureopps.ncmbc.us/" target="_blank" rel="noreferrer">http://futureopps.ncmbc.us/</a>
    </p>
  </div>
`;

const SearchFrame = () => {
  const { active, searchedData, totalCount, loading } = useContext(SearchContext);
  const location = useLocation(); 

  const titleFormat = (phrase, format) => {
    if (phrase === 'micro_purchases') {
      return 'local_opportunities' .replace(/\\/g, '')
      .toLowerCase()
      .split(format)
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
      .replace('b', 'B')
    } else {
    return phrase
      .replace(/\\/g, '')
      .toLowerCase()
      .split(format)
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
      .replace('b', 'B')
    }
  }

  const isClosed = () => {
    localStorage.setItem('futureOpportunityAlertMessage', JSON.stringify({wasClosed: true}))
  }

  const wasClosed = () => {
    return !!JSON.parse(localStorage.getItem('futureOpportunityAlertMessage'));
  }
  console.log(location.pathname)
  return (
    <Row>
      <Col>
        { active !== 'micro_purchases' && (
          <h3 className="mb-5">
            {active ? `${titleFormat(active, '_')} Search` : `${titleFormat(location.pathname, '-')} Search`}
          </h3>
        )}
        { active === 'micro_purchases' && (
          <h3 className="mb-5">
            Find Local Opportunities
          </h3>
        )}
        
        {
          active === 'future_opportunities' && !wasClosed() && (
            <AlertMessage 
              alertMessage={BUSINESS_ALERT}
              isClosed={isClosed}
            />
          )
        }
        <FullTextSearch 
          titleFormat={titleFormat}
        />
        {!searchedData.length && (
          <h3 className="my-5">No results</h3>
        )}
        {!!searchedData && !!searchedData.length && (
          <>
            <SearchSettings />
            <TableContainer />
          </>
        )}
        {searchedData && !!searchedData.length && !!totalCount && (
          <div className="pagination-wrap">
            <Pagination />
            <PageSwitcher />
          </div>
        )}
      </Col>
      {loading && <Loading />}
    </Row>
  )
}

export default SearchFrame;